// src/belediye/components/mesajlasma/olcu.js
// EKRAN ÖLÇÜSÜ — TEK KAYNAK.
//
// FAZ-60'ta ChatDock'a konulan "tek pencere eşiği" FAZ-66'da buraya taşındı:
// ChatThread'in de bilmesi gerekti (konum gönderirken mobilde OTOMATİK GPS
// aranıyor) ve ChatThread'in ChatDock'tan içe aktarması dairesel bağımlılık
// olurdu (ChatDock zaten ChatThread'i çekiyor).
//
// Eşiğin ALTI = telefon + dikey tablet: pencere tüm ekranı kaplar, tek pane,
// boy düğmeleri yok. Aynı CÜMLE chat.css'teki @media kurallarında da geçer —
// biri değişirse ÖTEKİ DE değişmeli.
//
// ── FAZ-78 — DİKEY TABLET GERÇEKTEN KAPSANIYOR ─────────────────────────────
// Kullanıcı (2026-07-30): "mobilde sohbet ekranı açılınca Kurum İçi Mesajlaşma
// kısmında sadece kapatma olsun; ikinci ekrana büyütme veya küçültme olmasın."
//
// Kural ZATEN vardı ama eşik tek bir genişlikti: 860px. FAZ-60'ın yorumu
// "telefon + DİKEY TABLET" diyor, oysa iPad Pro 12.9" dikey **1024px**, iPad
// Air dikey 820px — yani büyük tabletin dikey hâli eşiğin DIŞINDA kalıyordu:
// pencere kartta açılıyor, boy düğmeleri duruyordu. FAZ-73'te görev detayında
// yakalanan tuzağın aynısı (tek kırılım, gerçek cihaz genişliğinin yanından
// geçiyor).
//
// Artık eşik iki cümlelidir: yatayda 860, DİKEYDE 1100'e kadar. Dar masaüstü
// pencereleri (861–1023 yatay) etkilenmez — orada kart hâlâ anlamlı.
export const TEK_PENCERE_PX = 860;
export const TEK_PENCERE_DIKEY_PX = 1100;

export const TEK_PENCERE_SORGU =
  `(max-width: ${TEK_PENCERE_PX}px), (orientation: portrait) and (max-width: ${TEK_PENCERE_DIKEY_PX}px)`;

export const tekPencereMi = () =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia(TEK_PENCERE_SORGU).matches;
